import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/ai-hub/assistant/$assistantId')({
  preload: false,
})
